/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Invite_Already_AcceptedInputs */

const nl_invite_errors_invite_already_accepted = /** @type {(inputs: Invite_Errors_Invite_Already_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze uitnodiging is al geaccepteerd`)
};

/**

* @param {Invite_Errors_Invite_Already_AcceptedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_invite_already_accepted = /** @type {((inputs?: Invite_Errors_Invite_Already_AcceptedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Invite_Already_AcceptedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_invite_already_accepted(inputs)
});
export { invite_errors_invite_already_accepted as "invite.errors.invite_already_accepted" }